import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "react-bootstrap";
import CarrierwiseContainerReport from "../common/tables/CarrierwiseContainerReport";
import PortwiseContainerReport from "../common/tables/PortwiseContainerReport";
import store from "../../store/Store";
import { filter } from "lodash";

function ContainerReport() {
	const [type, setType] = useState("Port");
	const [userData, setUserData] = useState([]);
	const [filteredUserAccessData, setFilteredUserAccessData] = useState([]);

	useEffect(() => {
		const unsubscribe = store.subscribe(() => {
			setUserData(Object.values(store.getState().userAccessData));
		});
		return () => {
			unsubscribe();
		};
	});

	useEffect(() => {
		setUserData(Object.values(store.getState().userAccessData));
	}, [setUserData]);

	useEffect(() => {
		if (
			filter(userData, { MenuName: "Container Report", View: 1 }).length > 0
		) {
			setFilteredUserAccessData(
				filter(userData, { MenuName: "Container Report", View: 1 })
			);
		}
	}, [userData]);

	return (
		<>
			<div className="flex-row">
				<h1>Container Report</h1>
			</div>

			<Tabs
				activeKey={type}
				style={{
					marginBottom: "12px",
				}}
				onSelect={(k) => {
					setType(k);
				}}
			>
				<Tab eventKey="Port" title="Port">
					<PortwiseContainerReport
						filteredUserAccessData={filteredUserAccessData}
						type={type}
					/>
				</Tab>
				<Tab eventKey="Carrier" title="Carrier">
					<CarrierwiseContainerReport
						filteredUserAccessData={filteredUserAccessData}
						type={type}
					/>
				</Tab>
			</Tabs>
		</>
	);
}
export default ContainerReport;
